export default __webpack_public_path__ + "static/media/contacts.32e8b634.svg";